import { Component, Input, Output, OnInit,OnDestroy, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { Principal } from '../../../services/auth/principal.service';
import { UaaResourceService } from '../../../services/service/uaa-resource.service';
import { UserContextService } from '../../../services/service/user-context.service';
import { SubscriptionManager } from '../../../services/service/subscription-mamager';
import { NavMenu, NavMenuItem } from '../../model/nav-menu';

@Component({
    selector: 'zx-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit, OnDestroy {
    private _isInited = false;
    private _isCollapsed: boolean = false;
    private _navbarResourceName: any;
    private _treeViewData: any;
    private _navMenu: NavMenu;
    private _activeOnClick: boolean = false;
    private _accordion: boolean = true;
    private _navigationEndUrl: string;
    private _baseRouteUrl: string;
    isNavMenuLoading = false;

    @Input() autoSelectByRouter: boolean = false;
    @Input() disableNavAction: boolean = false;
    @Input() theme: string = 'light';
    @Output() selectChange: EventEmitter<any> = new EventEmitter();
    @Output() menuDataChange: EventEmitter<NavMenu> = new EventEmitter();

    constructor(
        private router: Router,
        private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private resourceService: UaaResourceService,
        private subscriptionManager: SubscriptionManager,
		private userContext: UserContextService
    ) {
    }

    ngOnInit() {
        // console.log("NavMenuComponent.ngOnInit: router =", this.router);
        this._navigationEndUrl = this.router.url;
        this.subscriptionManager.register(this, this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this._navigationEndUrl = (<NavigationEnd>event).url;
                this.selectMenuItemByUrl();
            }
        }));
		this.subscriptionManager.register(this, this.userContext.currentOfficeChange.subscribe(office=>{
            // console.log("NavMenuComponent -> currentOfficeChange.subscribe -> ", office);
            if(this._navbarResourceName!=null){
                this.initNavMenu(null, this._navbarResourceName);
            }else this.selectMenuItemByUrl();
        }));
    }
	ngOnDestroy(){
		this.subscriptionManager.unsubscribe(this);
	}
    private selectMenuItemByUrl() {
        if (this.navMenu && this.autoSelectByRouter && this._navigationEndUrl) {
            //const matchedMenuItem = this.navMenu.findItemByUrl(this._navigationEndUrl);
            const matchedMenuItem = this.navMenu.pathFromRootByUrl(this._navigationEndUrl).pop();
            
            this.navMenu.select(matchedMenuItem);
            if(!this._isCollapsed) this.navMenu.openToSelected();
        }
    }

    private initNavMenu(navMenu: NavMenu, navbarResourceName?: string, treeViewData?: any) {
        if (navMenu) {
            navMenu.root.baseRouteUrl = this.baseRouteUrl;
            // console.log("this.baseRouteUrl="+this.baseRouteUrl, this.baseRouteUrl, navMenu);
            this.isNavMenuLoading = false;
            if(navMenu.items.length > 0){
                this._navMenu = navMenu;
                this._navMenu.accordion = this.accordion;
                this._navMenu.activeOnClick = this.activeOnClick;
                this._navMenu.selectChange.subscribe(event => { this.selectChange.emit(event); });
                this.menuDataChange.emit(this._navMenu);
                this.selectMenuItemByUrl();
            }else{
                this._navMenu = null;
                this.menuDataChange.emit(null);
            }
        } else if (treeViewData) {
            this.initNavMenu(new NavMenu({ data: treeViewData }), null, null);
        } else {
            this.isNavMenuLoading = true;
            this._navMenu = null;
            if (navbarResourceName){
                const officeId = this.userContext.currentOfficeId;
                this.resourceService.getMyNavTree(this._navbarResourceName, {officeId:officeId}).then(navbar => {
                    if(navbarResourceName==this._navbarResourceName&&officeId==this.userContext.currentOfficeId)
                        this.initNavMenu(null, null, navbar);
                });
            }else{
                this.isNavMenuLoading = false;
                this.menuDataChange.emit(null);
            }
        }
    }
    hasPermission(menuItem:NavMenuItem):boolean{
        return this.principal.hasAnyAuthority(menuItem.data.authorities);
    }

    get accordion(): boolean {
        return this._accordion;
    }
    @Input() set accordion(v: boolean) {
        this._accordion = v;
        if (this._navMenu) this._navMenu.accordion = v;
    }
    get activeOnClick(): boolean {
        return this._activeOnClick;
    }
    @Input() set activeOnClick(v: boolean) {
        this._activeOnClick = v;
        if (this._navMenu) this._navMenu.activeOnClick = v;
    }

    get navbarResourceName(): string {
        return this._navbarResourceName;
    }
    @Input() set navbarResourceName(v: string) {
        if (this._navbarResourceName!=null&&this._navbarResourceName == v) return;

        this._navbarResourceName = v;
        this.initNavMenu(null, v);
    }

    get treeViewData(): string {
        return this._treeViewData;
    }
    @Input() set treeViewData(v: string) {
        if (this._treeViewData == v) return;

        this._treeViewData = v;
        this.initNavMenu(null, null, v);
    }

    get navMenu(): NavMenu {
        return this._navMenu;
    }
    @Input() set navMenu(v: NavMenu) {
        if (this._navMenu && v && this._navMenu.uuid == v.uuid) return;

        this._navMenu = v;
        this.initNavMenu(v, null);
    }

    get isCollapsed(): boolean {
        return this._isCollapsed;
    }
    @Input() set isCollapsed(v: boolean) {
        if (this._isCollapsed == v) return;

        this._isCollapsed = v;
        if (!v) setTimeout(() => {if(this.navMenu)this.navMenu.openToSelected();}, 100);
    }

    @Input() set baseRouteUrl(v:string) {
        if (this._baseRouteUrl == v) return;
        this._baseRouteUrl = v;
    }

    get baseRouteUrl() {
        return this._baseRouteUrl;
    }
}
